import { render } from "./ContentLoader.vue?vue&type=template&id=7e1f2360&scoped=true"
import script from "./ContentLoader.vue?vue&type=script&lang=js"
export * from "./ContentLoader.vue?vue&type=script&lang=js"

import "./ContentLoader.vue?vue&type=style&index=0&id=7e1f2360&lang=scss&scoped=true"

import exportComponent from "C:\\agent\\_work\\55\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e1f2360"]])

export default __exports__